import React from "react";
import { useTranslation } from "react-i18next";

interface DocumentsDownloadLoaderProps {
  onComplete?: () => void;
}

export const DocumentsDownloadLoader: React.FC<
  DocumentsDownloadLoaderProps
> = ({ onComplete }) => {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          {t("documents.download.preparing_zip")}
        </h2>
      </div>

      <div className="my-4">
        <div>
          <span>{t("documents.download.preparing_message")}</span>
        </div>
      </div>

      {/* Animation */}
      <div className="flex justify-center my-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-10 text-cyan-500 animate-spin"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        {/* <div className="relative h-16 w-16">
          <div className="absolute inset-0 animate-ping rounded-full bg-cyan-400 opacity-75"></div>
          <div className="relative flex h-16 w-16 items-center justify-center rounded-full bg-cyan-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25"
              />
            </svg>
          </div>
        </div> */}
      </div>
      <div className="text-gray-500 text-sm mt-4 text-center">
        {t("documents.download.please_wait")}
      </div>
    </div>
  );
};
